import { render, staticRenderFns } from "./Lotes.vue?vue&type=template&id=59e88762&scoped=true&"
import script from "./Lotes.vue?vue&type=script&lang=js&"
export * from "./Lotes.vue?vue&type=script&lang=js&"
import style0 from "./Lotes.vue?vue&type=style&index=0&id=59e88762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e88762",
  null
  
)

export default component.exports